import React from 'react';
import PropTypes from 'prop-types';
import styles from "../bigScreen.less";
import Gauge from './Gauge'
import Bar from './Bar'
import ModelBar from './ModelBar'
import Pie from './Pie'

function AppDetails(props) {
    const { model, getLangMsg, app } = props
    const { 
        Element = 10,
        Operator = 0,
        Service = 0, // 服务
        Entity = 0, // 业务对象模型
        PrintTemp = 0,
        
        Layout = 0, // 布局模型
        Validator = 0, // 校验器
        Parameter = 0, // 参数模型
        Report = 0, // 报表模型
        Page = 0, // 页面模型
        

        Mobile = 0, // 移动端
        Pc = 0, // pc

        Workflow = 0, //工作流
        Print = 0, // 打印模型
        Rule = 0, 
        RuleEntity = 0,// 规则模型
        Plugin = 0, //插件模型
        BizModelTemp = 0,

     } = app
     const pieData = [
        { value: Entity, name: getLangMsg('appDetails.key0012') },
        { value: Layout, name: getLangMsg('appDetails.key0013') },
        { value: Page, name: getLangMsg('appDetails.key0014') },
        { value: Report, name: getLangMsg('appDetails.key0015') },
        { value: Parameter, name: getLangMsg('appDetails.key0016') }
      ]
      let count = 0
      pieData.forEach(item => {
        count += item.value
      }) 

      // 求仪表盘的最大值
      const gaugeList = [Element, Rule, Operator, Service].sort((a,b) => a-b)
      let gaugeMax = gaugeList[gaugeList.length-1]
      gaugeList.forEach((item, index) => {
        if(item !== 0 && index !== gaugeList.length-1) {
            gaugeMax += item
        }
      })
    const test = getLangMsg('appDetails.key0001') 
    return (
        <div className={styles.appDetails}>
            <div className={styles.appDetailsContainer}>
                <div className={styles.appDetailsContainerLeft}>
                    {/* <div className={styles.appMetaTitle}><span>应用级元数据</span></div> */}
                    <div className={styles.appMetaTitle}><span>{getLangMsg('appDetails.key0001')}</span></div>
                    <div className={styles.appMetaDetails}>
                        <div className={styles.appMetaItem} style={{top: '-5px'}}>
                            <Gauge data={Element} gaugeMax={gaugeMax} color={'#5EC4FF'}/>
                            <div className={styles.appMetaItemTitle}>{getLangMsg('appDetails.key0002')}</div>
                        </div>
                        <div className={styles.appMetaItem} style={{top: '-5px'}}>
                            <Gauge data={Rule} gaugeMax={gaugeMax} color={'#9F49FF'}/>
                            <div className={styles.appMetaItemTitle}>{getLangMsg('appDetails.key0003')}</div>
                        </div>
                        <div className={styles.appMetaItem} style={{top: '-30px'}}>
                            <Gauge data={Operator} gaugeMax={gaugeMax} color={'#2DC076'}/>
                            <div className={styles.appMetaItemTitle}>{getLangMsg('appDetails.key0004')}</div>
                        </div>
                        <div className={styles.appMetaItem} style={{top: '-30px'}}>
                            <Gauge data={Service} gaugeMax={gaugeMax} color={'#D79E44'}/>
                            <div className={styles.appMetaItemTitle}>{getLangMsg('appDetails.key0005')}</div>
                        </div>
                    </div>
                    <div className={styles.appMetaTitle} style={{marginTop: '10px'}}><span>{getLangMsg('appDetails.key0006')}</span></div>
                    <div className={styles.appMetaName}>
                        <span className={styles.appMetaTemplate}>{getLangMsg('appDetails.key0007')}</span>
                        <span className={styles.appMetaTemplateNumber}>{BizModelTemp}</span>
                    </div>
                    <div className={styles.appTemplateDetails}><Bar data={BizModelTemp} total={props.bizModelTempTotal}/></div>
                    {/* <div className={styles.appTemplateDetails}><Bar data={20} total={50}/></div> */}
                </div>
                <div className={styles.appDetailsContainerRight}>
                    <div className={styles.appMetaTitle}><span>{getLangMsg('appDetails.key0008')}</span></div>
                    <div className={styles.appModel}>
                        <div className={styles.appModelLeft}>
                            <Pie pieData={pieData}/>
                            <div className={styles.appModelCircle}>
                                <div className={styles.appModelCircleChild}>
                                    <div className={styles.appModelNumbel}>{count}</div>
                                    <div className={styles.appModeltext}>{getLangMsg('appDetails.key0009')}</div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.appModelright}>
                            <div className={styles.pageModel}>
                                <div className={styles.pageModelPC}>
                                    <div className={styles.PCIcon}></div>
                                    <div className={styles.PCDetails}>
                                        <div className={styles.PCModelNumber}>{Pc}</div>
                                        <div className={styles.PCModelText}>{getLangMsg('appDetails.key0010')}</div>
                                    </div>
                                </div>
                                <div className={styles.split}></div>
                                <div className={styles.pageModelMobile}>
                                    <div className={styles.mobileIcon}></div>
                                    <div className={styles.PCDetails}>
                                        <div className={styles.PCModelNumber}>{Mobile}</div>
                                        <div className={styles.PCModelText}>{getLangMsg('appDetails.key0011')}</div>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.modelBar}>
                                <ModelBar Workflow={Workflow} Print={Print} Rule={RuleEntity} Plugin={Plugin} model={model} getLangMsg={getLangMsg} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
AppDetails.propTypes = {
    baseinfo: PropTypes.object,
    name: PropTypes.string
}
export default AppDetails;